import { API_BASE } from "../utils/baseapiurl";

class DashboardAPI {
	async getDashboardData(user_id, period = null) {
		const params = new URLSearchParams({
			...(user_id ? { user_id } : {}),
			...(period ? { period } : {}),
		});

		try {
			const response = await fetch(`${API_BASE}/dashboard?${params}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": window.wpApiSettings?.nonce || "",
				},
				credentials: "include",
			});

			if (!response.ok) {
				throw new Error("Failed to fetch dashboard");
			}

			return await response.json();
		} catch (error) {
			console.error("Error fetching dashboard:", error);
			throw error;
		}
	}
}
export default new DashboardAPI();
